module.exports = __webpack_public_path__ + "media/images/vp/samples/13-6e8c37e3235f90d79ecff523e67e6435.jpg";